import { useEffect, useState } from 'react';
import RichText from '@/components/atoms/rich-text/rich-text';
import Button from '@/components/molecules/button/button';
import Container from '@/components/utilities/container/container';
import styles from './onboarding-flow-membership-step-form-module.module.scss';

export type OnboardingFlowMembershipStepFormModuleProps = Omit<
  Content.Components['OnboardingFlowMembershipStepFormModuleDto'],
  '$type' | 'id' | 'pageId' | 'settings'
> & {
  /** Indicates the action is in progress */
  isLoading?: boolean;
  /** Callback fired when membership choice is made */
  onComplete?: (acceptedMembership: boolean) => Promise<void> | void;
};

const OnboardingFlowMembershipStepFormModule = ({
  buttonNoText,
  buttonYesText,
  isLoading = false,
  consentText,
  onComplete,
}: OnboardingFlowMembershipStepFormModuleProps) => {
  const [acceptMembership, setAcceptMembership] = useState(false);

  useEffect(() => {
    if (isLoading) return;

    setAcceptMembership(false);
  }, [isLoading]);

  const handleComplete = (accepted: boolean) => {
    setAcceptMembership(accepted);
    onComplete?.(accepted);
  };

  return (
    <div className={styles.component}>
      <Container className={styles.container}>
        <Button
          disabled={isLoading && !acceptMembership}
          isLoading={isLoading && acceptMembership}
          onClick={() => handleComplete(true)}
          text={buttonYesText}
          variant="primary"
        />

        <Button
          disabled={isLoading && acceptMembership}
          isLoading={isLoading && !acceptMembership}
          onClick={() => handleComplete(false)}
          text={buttonNoText}
          variant="secondary"
        />

        {consentText && (
          <RichText className={styles.consentText} text={consentText} />
        )}
      </Container>
    </div>
  );
};

OnboardingFlowMembershipStepFormModule.displayName =
  'OnboardingFlowMembershipStepFormModule';

export default OnboardingFlowMembershipStepFormModule;
